import { useForm } from 'react-hook-form';
import { resolver } from '../resolver';

const initialValues = {
  password: '',
};

export const useController = (options) => {
  const { onSubmit } = options;
  const {
    watch,
    control,
    handleSubmit,
  } = useForm({
    resolver,
    initialValues,
  });

  const password = watch('password');

  const submitHandler = handleSubmit(() => onSubmit(password));

  return {
    control,
    handleSubmit: submitHandler,
  };
};
